module.exports = __webpack_public_path__ + "assets/img/icon-zxdt-1.9f34aa54.png";